import { render, staticRenderFns } from "./TabPage.vue?vue&type=template&id=8026859a&scoped=true&"
import script from "./TabPage.vue?vue&type=script&lang=ts&"
export * from "./TabPage.vue?vue&type=script&lang=ts&"
import style0 from "./TabPage.vue?vue&type=style&index=0&id=8026859a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8026859a",
  null
  
)

export default component.exports